const generateFetcherKey = () =>
    `fetcherKey-${Math.floor(Math.random() * 99999).toString()}`;

export default generateFetcherKey;
